module.exports = __webpack_public_path__ + "img/process-1.892c3e54.png";